import client from '../client';

export const readHistoryList = () =>
    client.get('/api/chat/histories');

export const readHistoryDetail = ({ id, startkey }) =>
    client.get(`/api/chat/histories/${id}`, {
        params: {
            pagesize: 10,
            startkey: startkey ? startkey : null
        }
    });

export const updateHistoryTitle = ({ id, title }) =>
    client.patch(`/api/chat/histories/${id}`, {title});

export const updateHistoryPin = ({ id, isPinned }) =>
    client.patch(`/api/chat/histories/${id}`, {isPinned});

export const removeHistory = ({ id }) =>
    client.delete(`/api/chat/histories/${id}`);

export const createHistory = ({ title }) =>
    client.post('/api/chat/histories', {title});